import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { first, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { getAccountDetails } from '@aaa/emember/store-account';
import { ClubApp } from '@aaa/emember/types';
import { MembershipAssociateAddActions } from '@aaa/emember/store-membership-associate-add';
import { clubId } from '../../../signals';

export const setMembershipAssociateAddAccountDetails: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);

  return store.select(getAccountDetails).pipe(
    first((accountDetails) => !!accountDetails),
    tap((accountDetails) => {
      if (clubId() === ClubApp.MidStates && accountDetails) {
        store.dispatch(MembershipAssociateAddActions.setAccountDetails({ accountDetails }));
      }
    }),
    map(() => true),
  );
};

export default setMembershipAssociateAddAccountDetails;
